import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana109Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1420_9400)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M677.174 690.516L646.075 649.051L709.569 599.811C713.025 602.834 721.231 612.25 726.415 625.726C731.598 639.203 722.527 657.258 717.344 664.6L677.174 690.516Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M616.267 611.475L646.07 649.053L709.564 599.813L677.169 558.348L616.267 611.475Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M582.582 575.191L616.272 611.473L677.175 558.345L643.484 518.176L582.582 575.191Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M547.595 541.501L582.582 575.192L643.484 518.177L605.906 481.895L547.595 541.501Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M512.607 507.809L547.593 541.499L605.904 481.893L565.735 446.906L512.607 507.809Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M476.327 476.711L512.609 507.81L565.737 446.908L525.567 413.217L476.327 476.711Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M437.448 449.5L476.322 476.711L525.562 413.217L482.801 383.414L437.448 449.5Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M395.984 422.291L437.45 449.502L482.803 383.417L438.746 353.613L395.984 422.291Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M355.817 395.076L395.987 422.287L438.748 353.61L393.395 326.398L355.817 395.076Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M328.603 295.299C308.907 347.131 338.537 383.413 355.815 395.075L393.393 326.398L328.603 295.299Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1420_9400" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1420_9400" transform="matrix(0.0017774 0 0 0.00235636 -4.35902 -2.70765)"/>
    </pattern>
    <image id="image0_1420_9400" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};